<template>
  <div class="wrapper">
    <div class="gth"><van-icon name="fail" color="white" /></div>
    <div>数据加载失败</div>
    <!-- <div @click="refresh" class="btn">重新加载</div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods: {
    refresh(){
      this.$router.go(0)
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  overflow: auto;
  position: absolute;
  z-index: 99999999999;
  padding-top: 140px;
  text-align: center;
  font-size: 18px;
  letter-spacing: 1px;
  .gth{
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgb(251, 106, 106);
    text-align: center;
    margin: 0px auto;
    font-size: 60px;
    margin-bottom: 10px;
    .van-icon{
      margin-top: 10px;
    }
  }
  .btn{
    display: inline-block;
    border: 1px solid rgb(0, 191, 255);
    background: #87CEFA;
    margin-top: 6px;
    padding: 4px 12px;
    border-radius: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Reload/Reload.vue